<div class="cms-image" aria-hidden="true" [ngStyle]="{ 'background-image': cmsImage ? 'url(' + cmsImage + ')' : 'none'}"
    style="background-position: 0px 0px;">
    <div class="cmsTextGradient">
        <div class="heroOverlayText uhcWhite" style="opacity: 1.5;">
            <h2 class="uhcWhite">{{cmsTitle}}</h2>

        </div>
    </div>
</div>
<div class="main-content white">
    <div class="container" layout.xs="column">
        <div [ngSwitch]="contentType" id="cms">

            <ng-template ngSwitchCase="privacy-policies">
                <div fxLayout="row wrap" fxLayout.xs="column" layout-wrap fxLayoutAlign="space-between">
                    <mat-card appearance="outlined" class="cms-pdf-card" fxFlex="32" fxFlex.sm="48" fxFlex.xs="100"
                        *ngFor="let pdf of cmsPrivacyContentPdf">
                        <ng-container *ngIf="pdf?.Body[0]?.DisplayName != null || pdf.Body.Body != null">
                            <mat-card-content style="height:120px">
                                <div class="pdf-img">
                                    <img [src]="cmsPdfImage">
                                </div>
                                <div fxFlex="75" class="pdf-headline">
                                    <span>
                                        {{pdf?.Body[0]?.DisplayName || pdf.Body.Title}}
                                    </span>
                                </div>
                            </mat-card-content>
                            <mat-card-actions fxLayout="row" fxLayoutAlign="end center">
                                <a class="uhcLightBlue mat-button" target="_blank" rel="noopener noreferrer"
                                    aria-label="VIEW & DOWNLOAD"
                                    href="{{pdf?.Body[0]?.Id ? configService.cmsImageURL + pdf.Body[0].Id : pdf.Body.Body}}"
                                    title="View and download {{pdf?.Body[0]?.DisplayName ||  pdf.Body.Title}}"><span
                                        class="uhcFontBold ng-scope">VIEW & DOWNLOAD</span>
                                    <div class="md-ripple-container"></div>
                                </a>
                            </mat-card-actions>
                        </ng-container>
                    </mat-card>
                </div>
                <br />
                <div id="bottomText" [innerHTML]="cmsPrivacyContent"></div>
            </ng-template>
            <ng-template ngSwitchCase="contact-us" class="content">
                <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="32px">
                    <div fxFlex fxFlex.xs="100" [innerHTML]="cmsPageContent"></div>
                    <div fxFlex fxFlex.xs="100" *ngIf="cmsGlobalDataSchoolAdmins" [innerHTML]="cmsSchoolAdminsSection"></div>
                </div>
            </ng-template>
            <ng-template ngSwitchDefault>
                <div id="cms" [innerHTML]="cmsPageContent">
                </div>
            </ng-template>
        </div>
    </div>
</div>
